export class CallCenterTicketFileUploadOutDTO {
  originalFileName!: string;
  mimeType!: string;
  fileName!: string;
}
